/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Nikita Tropin <ntropin@yandex.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

export interface AnalogView {
  productId: number;
  productCode: string;
  productName: string;
  analogId: number;
  analogName: string;
  analogCode: string;
  type: string;
  typeId: number;
}
